export const hyperlite_gloves = {
  msrp: 34.99,
  infoLink: 'https://www.teamtriton.com/hyperlite-gloves.html',
  items: [
    {
      number: 'HBG001',
      hasModel: false,
    },
    {
      number: 'HBG002',
      hasModel: false,
    },
    {
      number: 'HBG003',
      hasModel: false,
    },
    {
      number: 'HBG004',
      hasModel: false,
    },
    {
      number: 'HBG005',
      hasModel: false,
    },
    {
      number: 'HBG006',
      hasModel: false,
    },
    {
      number: 'HBG007',
      hasModel: false,
    },
    {
      number: 'HBG008',
      hasModel: false,
    },
    {
      number: 'HBG009',
      hasModel: false,
    },
    {
      number: 'HBG010',
      hasModel: false,
    },
    {
      number: 'HBG011',
      hasModel: false,
    },
    {
      number: 'HBG012',
      hasModel: false,
    },
    {
      number: 'HBG013',
      hasModel: false,
    },
    {
      number: 'HBG014',
      hasModel: false,
    },
  ],
};
